/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddUserToChildOrganizationRequest } from '../models';
// @ts-ignore
import type { BatchCreateEnterpriseGroupsRequest } from '../models';
// @ts-ignore
import type { BatchCreateEnterpriseGroupsResponse } from '../models';
// @ts-ignore
import type { BatchCreateEnterpriseRoleBindingsRequest } from '../models';
// @ts-ignore
import type { BatchCreateEnterpriseRoleBindingsResponse } from '../models';
// @ts-ignore
import type { BatchCreateEnterpriseServiceAccountsRequest } from '../models';
// @ts-ignore
import type { BatchCreateEnterpriseServiceAccountsResponse } from '../models';
// @ts-ignore
import type { BatchDeleteEnterpriseGroupsRequest } from '../models';
// @ts-ignore
import type { BatchDeleteEnterpriseRoleBindingsRequest } from '../models';
// @ts-ignore
import type { BatchDeleteEnterpriseServiceAccountsRequest } from '../models';
// @ts-ignore
import type { BatchUpdateEnterpriseGroupsRequest } from '../models';
// @ts-ignore
import type { BatchUpdateEnterpriseGroupsResponse } from '../models';
// @ts-ignore
import type { BatchUpdateEnterpriseRoleBindingsRequest } from '../models';
// @ts-ignore
import type { BatchUpdateEnterpriseRoleBindingsResponse } from '../models';
// @ts-ignore
import type { BatchUpdateEnterpriseServiceAccountsRequest } from '../models';
// @ts-ignore
import type { BatchUpdateEnterpriseServiceAccountsResponse } from '../models';
// @ts-ignore
import type { CreateChildOrganizationRequestChildOrganization } from '../models';
// @ts-ignore
import type { CreateChildOrganizationResponse } from '../models';
// @ts-ignore
import type { GetEnterpriseGroupResponse } from '../models';
// @ts-ignore
import type { GetEnterpriseMemberResponse } from '../models';
// @ts-ignore
import type { InviteUsersRequest } from '../models';
// @ts-ignore
import type { ListChildrenOrganizationsResponse } from '../models';
// @ts-ignore
import type { ListEnterpriseServiceAccountsResponse } from '../models';
// @ts-ignore
import type { ListGroupsResponse } from '../models';
// @ts-ignore
import type { ListMembersResponse } from '../models';
// @ts-ignore
import type { ListRoleBindingsResponse } from '../models';
// @ts-ignore
import type { OverrideUserRoleBindingsRequest } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * EnterpriseAPIApi - axios parameter creator
 * @export
 */
export const EnterpriseAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add users to child organization
         * @param {string} enterpriseId Enterprise organization id which user is being managed.
         * @param {AddUserToChildOrganizationRequest} addUserToChildOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIAddUserToChildOrganization: async (enterpriseId: string, addUserToChildOrganizationRequest: AddUserToChildOrganizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIAddUserToChildOrganization', 'enterpriseId', enterpriseId)
            // verify required parameter 'addUserToChildOrganizationRequest' is not null or undefined
            assertParamExists('enterpriseAPIAddUserToChildOrganization', 'addUserToChildOrganizationRequest', addUserToChildOrganizationRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/users`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUserToChildOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch creates groups in an enterprise or child organizations
         * @summary Batch creates groups in an enterprise or child organizations.
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {BatchCreateEnterpriseGroupsRequest} batchCreateEnterpriseGroupsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchCreateEnterpriseGroups: async (enterpriseId: string, batchCreateEnterpriseGroupsRequest: BatchCreateEnterpriseGroupsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIBatchCreateEnterpriseGroups', 'enterpriseId', enterpriseId)
            // verify required parameter 'batchCreateEnterpriseGroupsRequest' is not null or undefined
            assertParamExists('enterpriseAPIBatchCreateEnterpriseGroups', 'batchCreateEnterpriseGroupsRequest', batchCreateEnterpriseGroupsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/groups:batchCreate`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCreateEnterpriseGroupsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch creates role bindings in an enterprise or child organizations
         * @summary Batch creates role bindings in an enterprise or child organizations.
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {BatchCreateEnterpriseRoleBindingsRequest} batchCreateEnterpriseRoleBindingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchCreateEnterpriseRoleBindings: async (enterpriseId: string, batchCreateEnterpriseRoleBindingsRequest: BatchCreateEnterpriseRoleBindingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIBatchCreateEnterpriseRoleBindings', 'enterpriseId', enterpriseId)
            // verify required parameter 'batchCreateEnterpriseRoleBindingsRequest' is not null or undefined
            assertParamExists('enterpriseAPIBatchCreateEnterpriseRoleBindings', 'batchCreateEnterpriseRoleBindingsRequest', batchCreateEnterpriseRoleBindingsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/role-bindings:batchCreate`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCreateEnterpriseRoleBindingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch creates service accounts in an enterprise or child organizations.
         * @summary Batch creates service accounts in an enterprise or child organizations.
         * @param {string} enterpriseId ID of the enterprise organization.
         * @param {BatchCreateEnterpriseServiceAccountsRequest} batchCreateEnterpriseServiceAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchCreateEnterpriseServiceAccounts: async (enterpriseId: string, batchCreateEnterpriseServiceAccountsRequest: BatchCreateEnterpriseServiceAccountsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIBatchCreateEnterpriseServiceAccounts', 'enterpriseId', enterpriseId)
            // verify required parameter 'batchCreateEnterpriseServiceAccountsRequest' is not null or undefined
            assertParamExists('enterpriseAPIBatchCreateEnterpriseServiceAccounts', 'batchCreateEnterpriseServiceAccountsRequest', batchCreateEnterpriseServiceAccountsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/service-accounts:batchCreate`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCreateEnterpriseServiceAccountsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch delete enterprise groups
         * @summary Batch delete enterprise groups.
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {BatchDeleteEnterpriseGroupsRequest} batchDeleteEnterpriseGroupsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchDeleteEnterpriseGroups: async (enterpriseId: string, batchDeleteEnterpriseGroupsRequest: BatchDeleteEnterpriseGroupsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIBatchDeleteEnterpriseGroups', 'enterpriseId', enterpriseId)
            // verify required parameter 'batchDeleteEnterpriseGroupsRequest' is not null or undefined
            assertParamExists('enterpriseAPIBatchDeleteEnterpriseGroups', 'batchDeleteEnterpriseGroupsRequest', batchDeleteEnterpriseGroupsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/groups:batchDelete`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchDeleteEnterpriseGroupsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch delete enterprise role bindings
         * @summary Batch delete enterprise role bindings.
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {BatchDeleteEnterpriseRoleBindingsRequest} batchDeleteEnterpriseRoleBindingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchDeleteEnterpriseRoleBindings: async (enterpriseId: string, batchDeleteEnterpriseRoleBindingsRequest: BatchDeleteEnterpriseRoleBindingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIBatchDeleteEnterpriseRoleBindings', 'enterpriseId', enterpriseId)
            // verify required parameter 'batchDeleteEnterpriseRoleBindingsRequest' is not null or undefined
            assertParamExists('enterpriseAPIBatchDeleteEnterpriseRoleBindings', 'batchDeleteEnterpriseRoleBindingsRequest', batchDeleteEnterpriseRoleBindingsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/role-bindings:batchDelete`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchDeleteEnterpriseRoleBindingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch delete enterprise service accounts
         * @summary Batch delete enterprise service accounts.
         * @param {string} enterpriseId ID of the enterprise organization.
         * @param {BatchDeleteEnterpriseServiceAccountsRequest} batchDeleteEnterpriseServiceAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchDeleteEnterpriseServiceAccounts: async (enterpriseId: string, batchDeleteEnterpriseServiceAccountsRequest: BatchDeleteEnterpriseServiceAccountsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIBatchDeleteEnterpriseServiceAccounts', 'enterpriseId', enterpriseId)
            // verify required parameter 'batchDeleteEnterpriseServiceAccountsRequest' is not null or undefined
            assertParamExists('enterpriseAPIBatchDeleteEnterpriseServiceAccounts', 'batchDeleteEnterpriseServiceAccountsRequest', batchDeleteEnterpriseServiceAccountsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/service-accounts:batchDelete`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchDeleteEnterpriseServiceAccountsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch updates groups in an enterprise or child organizations
         * @summary Batch updates groups in an enterprise or child organizations.
         * @param {string} enterpriseId Required field that identifies the enterprise.  If this is set, the organization_id field in the UpdateGroupRequest messages  must either be empty or match organizations within this enterprise.
         * @param {BatchUpdateEnterpriseGroupsRequest} batchUpdateEnterpriseGroupsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchUpdateEnterpriseGroups: async (enterpriseId: string, batchUpdateEnterpriseGroupsRequest: BatchUpdateEnterpriseGroupsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIBatchUpdateEnterpriseGroups', 'enterpriseId', enterpriseId)
            // verify required parameter 'batchUpdateEnterpriseGroupsRequest' is not null or undefined
            assertParamExists('enterpriseAPIBatchUpdateEnterpriseGroups', 'batchUpdateEnterpriseGroupsRequest', batchUpdateEnterpriseGroupsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/groups:batchUpdate`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUpdateEnterpriseGroupsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a batch of enterprise role bindings.
         * @summary Batch update enterprise role bindings
         * @param {string} enterpriseId The ID of the enterprise.
         * @param {BatchUpdateEnterpriseRoleBindingsRequest} batchUpdateEnterpriseRoleBindingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchUpdateEnterpriseRoleBindings: async (enterpriseId: string, batchUpdateEnterpriseRoleBindingsRequest: BatchUpdateEnterpriseRoleBindingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIBatchUpdateEnterpriseRoleBindings', 'enterpriseId', enterpriseId)
            // verify required parameter 'batchUpdateEnterpriseRoleBindingsRequest' is not null or undefined
            assertParamExists('enterpriseAPIBatchUpdateEnterpriseRoleBindings', 'batchUpdateEnterpriseRoleBindingsRequest', batchUpdateEnterpriseRoleBindingsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/role-bindings:batchUpdate`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUpdateEnterpriseRoleBindingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch updates service accounts in an enterprise or child organizations.
         * @summary Batch updates service accounts in an enterprise or child organizations.
         * @param {string} enterpriseId ID of the enterprise organization.
         * @param {BatchUpdateEnterpriseServiceAccountsRequest} batchUpdateEnterpriseServiceAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchUpdateEnterpriseServiceAccounts: async (enterpriseId: string, batchUpdateEnterpriseServiceAccountsRequest: BatchUpdateEnterpriseServiceAccountsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIBatchUpdateEnterpriseServiceAccounts', 'enterpriseId', enterpriseId)
            // verify required parameter 'batchUpdateEnterpriseServiceAccountsRequest' is not null or undefined
            assertParamExists('enterpriseAPIBatchUpdateEnterpriseServiceAccounts', 'batchUpdateEnterpriseServiceAccountsRequest', batchUpdateEnterpriseServiceAccountsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/service-accounts:batchUpdate`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUpdateEnterpriseServiceAccountsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates child organization for an enterprise
         * @summary Create child organization for an enterprise organization
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {CreateChildOrganizationRequestChildOrganization} createChildOrganizationRequestChildOrganization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPICreateChildOrganization: async (enterpriseId: string, createChildOrganizationRequestChildOrganization: CreateChildOrganizationRequestChildOrganization, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPICreateChildOrganization', 'enterpriseId', enterpriseId)
            // verify required parameter 'createChildOrganizationRequestChildOrganization' is not null or undefined
            assertParamExists('enterpriseAPICreateChildOrganization', 'createChildOrganizationRequestChildOrganization', createChildOrganizationRequestChildOrganization)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/organizations`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChildOrganizationRequestChildOrganization, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes child organization for an enterprise
         * @summary Delete child organization for an enterprise organization
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {string} id Required field that identifies the child organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIDeleteChildOrganization: async (enterpriseId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIDeleteChildOrganization', 'enterpriseId', enterpriseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enterpriseAPIDeleteChildOrganization', 'id', id)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/organizations/{id}`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetEnterpriseGroup returns the group of an enterprise organization
         * @summary Get enterprise group.
         * @param {string} enterpriseId ID of the enterprise organization to which the group belongs.  Required field that identifies the enterprise.
         * @param {string} id ID of the group to retrieve. Allows cross-organization lookup under the  enterprise - the group may belong to the parent enterprise or any of its  child organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIGetEnterpriseGroup: async (enterpriseId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIGetEnterpriseGroup', 'enterpriseId', enterpriseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enterpriseAPIGetEnterpriseGroup', 'id', id)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/groups/{id}`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a single enterprise member (user or invitation) by id from the enterprise or its child organizations.
         * @summary Get a single enterprise member (user or invitation) by id.
         * @param {string} enterpriseId ID of the enterprise organization that owns the member.  Required field that identifies the enterprise (or one of its child organizations).
         * @param {string} id ID of the member (user or invitation) to fetch.
         * @param {EnterpriseAPIGetEnterpriseMemberTypeEnum} [type] Kind of member to fetch. Required; must be either USER or INVITATION.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIGetEnterpriseMember: async (enterpriseId: string, id: string, type?: EnterpriseAPIGetEnterpriseMemberTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIGetEnterpriseMember', 'enterpriseId', enterpriseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enterpriseAPIGetEnterpriseMember', 'id', id)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/members/{id}`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create invitations for multiple users to join child organizations by email
         * @summary Invite users to child organizations.
         * @param {string} enterpriseId ID of the enterprise organization to invite users to.  Required field that identifies the enterprise.
         * @param {InviteUsersRequest} inviteUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIInviteUsers: async (enterpriseId: string, inviteUsersRequest: InviteUsersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIInviteUsers', 'enterpriseId', enterpriseId)
            // verify required parameter 'inviteUsersRequest' is not null or undefined
            assertParamExists('enterpriseAPIInviteUsers', 'inviteUsersRequest', inviteUsersRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/invitations`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUsersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all children organizations of the enterprise from the token.
         * @summary List all children organizations of the enterprise from the token.
         * @param {string} enterpriseId Get organization children by organization id.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [organizationName] Filter by organization name
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {EnterpriseAPIListChildrenOrganizationsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListChildrenOrganizations: async (enterpriseId: string, pageLimit?: string, pageCursor?: string, organizationName?: string, sortField?: string, sortOrder?: EnterpriseAPIListChildrenOrganizationsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIListChildrenOrganizations', 'enterpriseId', enterpriseId)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/organizations`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (organizationName !== undefined) {
                localVarQueryParameter['organizationName'] = organizationName;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all enterprise and child organizations service accounts
         * @summary List all enterprise and child organizations service accounts.
         * @param {string} enterpriseId ID of the enterprise organization to list service accounts from.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [organizationId] Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y).
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {EnterpriseAPIListEnterpriseServiceAccountsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {string} [name] Filter by name. Performs case-insensitive partial matching.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListEnterpriseServiceAccounts: async (enterpriseId: string, pageLimit?: string, pageCursor?: string, organizationId?: Array<string>, sortField?: string, sortOrder?: EnterpriseAPIListEnterpriseServiceAccountsSortOrderEnum, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIListEnterpriseServiceAccounts', 'enterpriseId', enterpriseId)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/service-accounts`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (organizationId) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all enterprise and child organizations groups
         * @summary List all enterprise and child organizations groups.
         * @param {string} enterpriseId ID of the enterprise organization to list groups from.  Required field that identifies the enterprise.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [organizationId] Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y)
         * @param {string} [groupName] Filter by group name
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {EnterpriseAPIListGroupsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListGroups: async (enterpriseId: string, pageLimit?: string, pageCursor?: string, organizationId?: Array<string>, groupName?: string, sortField?: string, sortOrder?: EnterpriseAPIListGroupsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIListGroups', 'enterpriseId', enterpriseId)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/groups`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (organizationId) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (groupName !== undefined) {
                localVarQueryParameter['groupName'] = groupName;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all enterprise and child organizations users and invitations
         * @summary List all enterprise and child organizations users and invitations.
         * @param {string} enterpriseId ID of the enterprise organization to list users from  Required field that identifies the enterprise
         * @param {Array<string>} [organizationId] Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y)
         * @param {Array<string>} [roleId] Filter by role ID. Multiple values can be passed as query parameters (e.g.,  &amp;role_id&#x3D;x&amp;role_id&#x3D;y)
         * @param {Array<string>} [groupId] Filter by group ID. Multiple values can be passed as query parameters  (e.g., &amp;group_id&#x3D;x&amp;group_id&#x3D;y)
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [name] Filter by name.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {EnterpriseAPIListMembersSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {EnterpriseAPIListMembersStatusEnum} [status] Filter by status. Default is ALL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListMembers: async (enterpriseId: string, organizationId?: Array<string>, roleId?: Array<string>, groupId?: Array<string>, pageLimit?: string, pageCursor?: string, name?: string, sortField?: string, sortOrder?: EnterpriseAPIListMembersSortOrderEnum, status?: EnterpriseAPIListMembersStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIListMembers', 'enterpriseId', enterpriseId)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/members`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (roleId) {
                localVarQueryParameter['roleId'] = roleId;
            }

            if (groupId) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all enterprise and child organizations role bindings
         * @summary List all enterprise and child organizations role bindings.
         * @param {string} enterpriseId ID of the enterprise organization to list role bindings from.  Required field that identifies the enterprise.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [organizationId] Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y)
         * @param {Array<string>} [roleId] Filter by role ID. Multiple values can be passed as query parameters (e.g.,  &amp;role_id&#x3D;x&amp;role_id&#x3D;y)
         * @param {Array<string>} [subjectId] Filter by subject ID. Multiple values can be passed as query parameters (e.g.,  &amp;subject_id&#x3D;x&amp;subject_id&#x3D;y)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListRoleBindings: async (enterpriseId: string, pageLimit?: string, pageCursor?: string, organizationId?: Array<string>, roleId?: Array<string>, subjectId?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIListRoleBindings', 'enterpriseId', enterpriseId)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/role-bindings`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (organizationId) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (roleId) {
                localVarQueryParameter['roleId'] = roleId;
            }

            if (subjectId) {
                localVarQueryParameter['subjectId'] = subjectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override users role bindings for enterprise and child organizations
         * @summary Override user role bindings for enterprise and child organizations
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {OverrideUserRoleBindingsRequest} overrideUserRoleBindingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIOverrideUserRoleBindings: async (enterpriseId: string, overrideUserRoleBindingsRequest: OverrideUserRoleBindingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('enterpriseAPIOverrideUserRoleBindings', 'enterpriseId', enterpriseId)
            // verify required parameter 'overrideUserRoleBindingsRequest' is not null or undefined
            assertParamExists('enterpriseAPIOverrideUserRoleBindings', 'overrideUserRoleBindingsRequest', overrideUserRoleBindingsRequest)
            const localVarPath = `/organization-management/v1/enterprises/{enterpriseId}/users:overrideRoleBindings`
                .replace(`{${"enterpriseId"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overrideUserRoleBindingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnterpriseAPIApi - functional programming interface
 * @export
 */
export const EnterpriseAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnterpriseAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Add users to child organization
         * @param {string} enterpriseId Enterprise organization id which user is being managed.
         * @param {AddUserToChildOrganizationRequest} addUserToChildOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIAddUserToChildOrganization(enterpriseId: string, addUserToChildOrganizationRequest: AddUserToChildOrganizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIAddUserToChildOrganization(enterpriseId, addUserToChildOrganizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIAddUserToChildOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch creates groups in an enterprise or child organizations
         * @summary Batch creates groups in an enterprise or child organizations.
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {BatchCreateEnterpriseGroupsRequest} batchCreateEnterpriseGroupsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIBatchCreateEnterpriseGroups(enterpriseId: string, batchCreateEnterpriseGroupsRequest: BatchCreateEnterpriseGroupsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchCreateEnterpriseGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIBatchCreateEnterpriseGroups(enterpriseId, batchCreateEnterpriseGroupsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIBatchCreateEnterpriseGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch creates role bindings in an enterprise or child organizations
         * @summary Batch creates role bindings in an enterprise or child organizations.
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {BatchCreateEnterpriseRoleBindingsRequest} batchCreateEnterpriseRoleBindingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIBatchCreateEnterpriseRoleBindings(enterpriseId: string, batchCreateEnterpriseRoleBindingsRequest: BatchCreateEnterpriseRoleBindingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchCreateEnterpriseRoleBindingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIBatchCreateEnterpriseRoleBindings(enterpriseId, batchCreateEnterpriseRoleBindingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIBatchCreateEnterpriseRoleBindings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch creates service accounts in an enterprise or child organizations.
         * @summary Batch creates service accounts in an enterprise or child organizations.
         * @param {string} enterpriseId ID of the enterprise organization.
         * @param {BatchCreateEnterpriseServiceAccountsRequest} batchCreateEnterpriseServiceAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIBatchCreateEnterpriseServiceAccounts(enterpriseId: string, batchCreateEnterpriseServiceAccountsRequest: BatchCreateEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchCreateEnterpriseServiceAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIBatchCreateEnterpriseServiceAccounts(enterpriseId, batchCreateEnterpriseServiceAccountsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIBatchCreateEnterpriseServiceAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch delete enterprise groups
         * @summary Batch delete enterprise groups.
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {BatchDeleteEnterpriseGroupsRequest} batchDeleteEnterpriseGroupsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIBatchDeleteEnterpriseGroups(enterpriseId: string, batchDeleteEnterpriseGroupsRequest: BatchDeleteEnterpriseGroupsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIBatchDeleteEnterpriseGroups(enterpriseId, batchDeleteEnterpriseGroupsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIBatchDeleteEnterpriseGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch delete enterprise role bindings
         * @summary Batch delete enterprise role bindings.
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {BatchDeleteEnterpriseRoleBindingsRequest} batchDeleteEnterpriseRoleBindingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIBatchDeleteEnterpriseRoleBindings(enterpriseId: string, batchDeleteEnterpriseRoleBindingsRequest: BatchDeleteEnterpriseRoleBindingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIBatchDeleteEnterpriseRoleBindings(enterpriseId, batchDeleteEnterpriseRoleBindingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIBatchDeleteEnterpriseRoleBindings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch delete enterprise service accounts
         * @summary Batch delete enterprise service accounts.
         * @param {string} enterpriseId ID of the enterprise organization.
         * @param {BatchDeleteEnterpriseServiceAccountsRequest} batchDeleteEnterpriseServiceAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIBatchDeleteEnterpriseServiceAccounts(enterpriseId: string, batchDeleteEnterpriseServiceAccountsRequest: BatchDeleteEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIBatchDeleteEnterpriseServiceAccounts(enterpriseId, batchDeleteEnterpriseServiceAccountsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIBatchDeleteEnterpriseServiceAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch updates groups in an enterprise or child organizations
         * @summary Batch updates groups in an enterprise or child organizations.
         * @param {string} enterpriseId Required field that identifies the enterprise.  If this is set, the organization_id field in the UpdateGroupRequest messages  must either be empty or match organizations within this enterprise.
         * @param {BatchUpdateEnterpriseGroupsRequest} batchUpdateEnterpriseGroupsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIBatchUpdateEnterpriseGroups(enterpriseId: string, batchUpdateEnterpriseGroupsRequest: BatchUpdateEnterpriseGroupsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchUpdateEnterpriseGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIBatchUpdateEnterpriseGroups(enterpriseId, batchUpdateEnterpriseGroupsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIBatchUpdateEnterpriseGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a batch of enterprise role bindings.
         * @summary Batch update enterprise role bindings
         * @param {string} enterpriseId The ID of the enterprise.
         * @param {BatchUpdateEnterpriseRoleBindingsRequest} batchUpdateEnterpriseRoleBindingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIBatchUpdateEnterpriseRoleBindings(enterpriseId: string, batchUpdateEnterpriseRoleBindingsRequest: BatchUpdateEnterpriseRoleBindingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchUpdateEnterpriseRoleBindingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIBatchUpdateEnterpriseRoleBindings(enterpriseId, batchUpdateEnterpriseRoleBindingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIBatchUpdateEnterpriseRoleBindings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch updates service accounts in an enterprise or child organizations.
         * @summary Batch updates service accounts in an enterprise or child organizations.
         * @param {string} enterpriseId ID of the enterprise organization.
         * @param {BatchUpdateEnterpriseServiceAccountsRequest} batchUpdateEnterpriseServiceAccountsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIBatchUpdateEnterpriseServiceAccounts(enterpriseId: string, batchUpdateEnterpriseServiceAccountsRequest: BatchUpdateEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchUpdateEnterpriseServiceAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIBatchUpdateEnterpriseServiceAccounts(enterpriseId, batchUpdateEnterpriseServiceAccountsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIBatchUpdateEnterpriseServiceAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates child organization for an enterprise
         * @summary Create child organization for an enterprise organization
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {CreateChildOrganizationRequestChildOrganization} createChildOrganizationRequestChildOrganization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPICreateChildOrganization(enterpriseId: string, createChildOrganizationRequestChildOrganization: CreateChildOrganizationRequestChildOrganization, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChildOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPICreateChildOrganization(enterpriseId, createChildOrganizationRequestChildOrganization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPICreateChildOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes child organization for an enterprise
         * @summary Delete child organization for an enterprise organization
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {string} id Required field that identifies the child organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIDeleteChildOrganization(enterpriseId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIDeleteChildOrganization(enterpriseId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIDeleteChildOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetEnterpriseGroup returns the group of an enterprise organization
         * @summary Get enterprise group.
         * @param {string} enterpriseId ID of the enterprise organization to which the group belongs.  Required field that identifies the enterprise.
         * @param {string} id ID of the group to retrieve. Allows cross-organization lookup under the  enterprise - the group may belong to the parent enterprise or any of its  child organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIGetEnterpriseGroup(enterpriseId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnterpriseGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIGetEnterpriseGroup(enterpriseId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIGetEnterpriseGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a single enterprise member (user or invitation) by id from the enterprise or its child organizations.
         * @summary Get a single enterprise member (user or invitation) by id.
         * @param {string} enterpriseId ID of the enterprise organization that owns the member.  Required field that identifies the enterprise (or one of its child organizations).
         * @param {string} id ID of the member (user or invitation) to fetch.
         * @param {EnterpriseAPIGetEnterpriseMemberTypeEnum} [type] Kind of member to fetch. Required; must be either USER or INVITATION.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIGetEnterpriseMember(enterpriseId: string, id: string, type?: EnterpriseAPIGetEnterpriseMemberTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnterpriseMemberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIGetEnterpriseMember(enterpriseId, id, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIGetEnterpriseMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create invitations for multiple users to join child organizations by email
         * @summary Invite users to child organizations.
         * @param {string} enterpriseId ID of the enterprise organization to invite users to.  Required field that identifies the enterprise.
         * @param {InviteUsersRequest} inviteUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIInviteUsers(enterpriseId: string, inviteUsersRequest: InviteUsersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIInviteUsers(enterpriseId, inviteUsersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIInviteUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all children organizations of the enterprise from the token.
         * @summary List all children organizations of the enterprise from the token.
         * @param {string} enterpriseId Get organization children by organization id.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [organizationName] Filter by organization name
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {EnterpriseAPIListChildrenOrganizationsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIListChildrenOrganizations(enterpriseId: string, pageLimit?: string, pageCursor?: string, organizationName?: string, sortField?: string, sortOrder?: EnterpriseAPIListChildrenOrganizationsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListChildrenOrganizationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIListChildrenOrganizations(enterpriseId, pageLimit, pageCursor, organizationName, sortField, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIListChildrenOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all enterprise and child organizations service accounts
         * @summary List all enterprise and child organizations service accounts.
         * @param {string} enterpriseId ID of the enterprise organization to list service accounts from.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [organizationId] Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y).
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {EnterpriseAPIListEnterpriseServiceAccountsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {string} [name] Filter by name. Performs case-insensitive partial matching.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIListEnterpriseServiceAccounts(enterpriseId: string, pageLimit?: string, pageCursor?: string, organizationId?: Array<string>, sortField?: string, sortOrder?: EnterpriseAPIListEnterpriseServiceAccountsSortOrderEnum, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEnterpriseServiceAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIListEnterpriseServiceAccounts(enterpriseId, pageLimit, pageCursor, organizationId, sortField, sortOrder, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIListEnterpriseServiceAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all enterprise and child organizations groups
         * @summary List all enterprise and child organizations groups.
         * @param {string} enterpriseId ID of the enterprise organization to list groups from.  Required field that identifies the enterprise.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [organizationId] Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y)
         * @param {string} [groupName] Filter by group name
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {EnterpriseAPIListGroupsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIListGroups(enterpriseId: string, pageLimit?: string, pageCursor?: string, organizationId?: Array<string>, groupName?: string, sortField?: string, sortOrder?: EnterpriseAPIListGroupsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIListGroups(enterpriseId, pageLimit, pageCursor, organizationId, groupName, sortField, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIListGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all enterprise and child organizations users and invitations
         * @summary List all enterprise and child organizations users and invitations.
         * @param {string} enterpriseId ID of the enterprise organization to list users from  Required field that identifies the enterprise
         * @param {Array<string>} [organizationId] Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y)
         * @param {Array<string>} [roleId] Filter by role ID. Multiple values can be passed as query parameters (e.g.,  &amp;role_id&#x3D;x&amp;role_id&#x3D;y)
         * @param {Array<string>} [groupId] Filter by group ID. Multiple values can be passed as query parameters  (e.g., &amp;group_id&#x3D;x&amp;group_id&#x3D;y)
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [name] Filter by name.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {EnterpriseAPIListMembersSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {EnterpriseAPIListMembersStatusEnum} [status] Filter by status. Default is ALL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIListMembers(enterpriseId: string, organizationId?: Array<string>, roleId?: Array<string>, groupId?: Array<string>, pageLimit?: string, pageCursor?: string, name?: string, sortField?: string, sortOrder?: EnterpriseAPIListMembersSortOrderEnum, status?: EnterpriseAPIListMembersStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIListMembers(enterpriseId, organizationId, roleId, groupId, pageLimit, pageCursor, name, sortField, sortOrder, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIListMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all enterprise and child organizations role bindings
         * @summary List all enterprise and child organizations role bindings.
         * @param {string} enterpriseId ID of the enterprise organization to list role bindings from.  Required field that identifies the enterprise.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [organizationId] Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y)
         * @param {Array<string>} [roleId] Filter by role ID. Multiple values can be passed as query parameters (e.g.,  &amp;role_id&#x3D;x&amp;role_id&#x3D;y)
         * @param {Array<string>} [subjectId] Filter by subject ID. Multiple values can be passed as query parameters (e.g.,  &amp;subject_id&#x3D;x&amp;subject_id&#x3D;y)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIListRoleBindings(enterpriseId: string, pageLimit?: string, pageCursor?: string, organizationId?: Array<string>, roleId?: Array<string>, subjectId?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRoleBindingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIListRoleBindings(enterpriseId, pageLimit, pageCursor, organizationId, roleId, subjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIListRoleBindings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Override users role bindings for enterprise and child organizations
         * @summary Override user role bindings for enterprise and child organizations
         * @param {string} enterpriseId Required field that identifies the enterprise.
         * @param {OverrideUserRoleBindingsRequest} overrideUserRoleBindingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseAPIOverrideUserRoleBindings(enterpriseId: string, overrideUserRoleBindingsRequest: OverrideUserRoleBindingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseAPIOverrideUserRoleBindings(enterpriseId, overrideUserRoleBindingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseAPIApi.enterpriseAPIOverrideUserRoleBindings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnterpriseAPIApi - factory interface
 * @export
 */
export const EnterpriseAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnterpriseAPIApiFp(configuration)
    return {
        /**
         * Add users to child organization
         * @param {EnterpriseAPIApiEnterpriseAPIAddUserToChildOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIAddUserToChildOrganization(requestParameters: EnterpriseAPIApiEnterpriseAPIAddUserToChildOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.enterpriseAPIAddUserToChildOrganization(requestParameters.enterpriseId, requestParameters.addUserToChildOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch creates groups in an enterprise or child organizations
         * @summary Batch creates groups in an enterprise or child organizations.
         * @param {EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchCreateEnterpriseGroups(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchCreateEnterpriseGroupsResponse> {
            return localVarFp.enterpriseAPIBatchCreateEnterpriseGroups(requestParameters.enterpriseId, requestParameters.batchCreateEnterpriseGroupsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch creates role bindings in an enterprise or child organizations
         * @summary Batch creates role bindings in an enterprise or child organizations.
         * @param {EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseRoleBindingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchCreateEnterpriseRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseRoleBindingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchCreateEnterpriseRoleBindingsResponse> {
            return localVarFp.enterpriseAPIBatchCreateEnterpriseRoleBindings(requestParameters.enterpriseId, requestParameters.batchCreateEnterpriseRoleBindingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch creates service accounts in an enterprise or child organizations.
         * @summary Batch creates service accounts in an enterprise or child organizations.
         * @param {EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseServiceAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchCreateEnterpriseServiceAccounts(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchCreateEnterpriseServiceAccountsResponse> {
            return localVarFp.enterpriseAPIBatchCreateEnterpriseServiceAccounts(requestParameters.enterpriseId, requestParameters.batchCreateEnterpriseServiceAccountsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch delete enterprise groups
         * @summary Batch delete enterprise groups.
         * @param {EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchDeleteEnterpriseGroups(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enterpriseAPIBatchDeleteEnterpriseGroups(requestParameters.enterpriseId, requestParameters.batchDeleteEnterpriseGroupsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch delete enterprise role bindings
         * @summary Batch delete enterprise role bindings.
         * @param {EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseRoleBindingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchDeleteEnterpriseRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseRoleBindingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enterpriseAPIBatchDeleteEnterpriseRoleBindings(requestParameters.enterpriseId, requestParameters.batchDeleteEnterpriseRoleBindingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch delete enterprise service accounts
         * @summary Batch delete enterprise service accounts.
         * @param {EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseServiceAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchDeleteEnterpriseServiceAccounts(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enterpriseAPIBatchDeleteEnterpriseServiceAccounts(requestParameters.enterpriseId, requestParameters.batchDeleteEnterpriseServiceAccountsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch updates groups in an enterprise or child organizations
         * @summary Batch updates groups in an enterprise or child organizations.
         * @param {EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchUpdateEnterpriseGroups(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUpdateEnterpriseGroupsResponse> {
            return localVarFp.enterpriseAPIBatchUpdateEnterpriseGroups(requestParameters.enterpriseId, requestParameters.batchUpdateEnterpriseGroupsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a batch of enterprise role bindings.
         * @summary Batch update enterprise role bindings
         * @param {EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseRoleBindingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchUpdateEnterpriseRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseRoleBindingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUpdateEnterpriseRoleBindingsResponse> {
            return localVarFp.enterpriseAPIBatchUpdateEnterpriseRoleBindings(requestParameters.enterpriseId, requestParameters.batchUpdateEnterpriseRoleBindingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch updates service accounts in an enterprise or child organizations.
         * @summary Batch updates service accounts in an enterprise or child organizations.
         * @param {EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseServiceAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIBatchUpdateEnterpriseServiceAccounts(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUpdateEnterpriseServiceAccountsResponse> {
            return localVarFp.enterpriseAPIBatchUpdateEnterpriseServiceAccounts(requestParameters.enterpriseId, requestParameters.batchUpdateEnterpriseServiceAccountsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates child organization for an enterprise
         * @summary Create child organization for an enterprise organization
         * @param {EnterpriseAPIApiEnterpriseAPICreateChildOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPICreateChildOrganization(requestParameters: EnterpriseAPIApiEnterpriseAPICreateChildOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateChildOrganizationResponse> {
            return localVarFp.enterpriseAPICreateChildOrganization(requestParameters.enterpriseId, requestParameters.createChildOrganizationRequestChildOrganization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes child organization for an enterprise
         * @summary Delete child organization for an enterprise organization
         * @param {EnterpriseAPIApiEnterpriseAPIDeleteChildOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIDeleteChildOrganization(requestParameters: EnterpriseAPIApiEnterpriseAPIDeleteChildOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enterpriseAPIDeleteChildOrganization(requestParameters.enterpriseId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * GetEnterpriseGroup returns the group of an enterprise organization
         * @summary Get enterprise group.
         * @param {EnterpriseAPIApiEnterpriseAPIGetEnterpriseGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIGetEnterpriseGroup(requestParameters: EnterpriseAPIApiEnterpriseAPIGetEnterpriseGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEnterpriseGroupResponse> {
            return localVarFp.enterpriseAPIGetEnterpriseGroup(requestParameters.enterpriseId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a single enterprise member (user or invitation) by id from the enterprise or its child organizations.
         * @summary Get a single enterprise member (user or invitation) by id.
         * @param {EnterpriseAPIApiEnterpriseAPIGetEnterpriseMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIGetEnterpriseMember(requestParameters: EnterpriseAPIApiEnterpriseAPIGetEnterpriseMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEnterpriseMemberResponse> {
            return localVarFp.enterpriseAPIGetEnterpriseMember(requestParameters.enterpriseId, requestParameters.id, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Create invitations for multiple users to join child organizations by email
         * @summary Invite users to child organizations.
         * @param {EnterpriseAPIApiEnterpriseAPIInviteUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIInviteUsers(requestParameters: EnterpriseAPIApiEnterpriseAPIInviteUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.enterpriseAPIInviteUsers(requestParameters.enterpriseId, requestParameters.inviteUsersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List all children organizations of the enterprise from the token.
         * @summary List all children organizations of the enterprise from the token.
         * @param {EnterpriseAPIApiEnterpriseAPIListChildrenOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListChildrenOrganizations(requestParameters: EnterpriseAPIApiEnterpriseAPIListChildrenOrganizationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListChildrenOrganizationsResponse> {
            return localVarFp.enterpriseAPIListChildrenOrganizations(requestParameters.enterpriseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.organizationName, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * List all enterprise and child organizations service accounts
         * @summary List all enterprise and child organizations service accounts.
         * @param {EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListEnterpriseServiceAccounts(requestParameters: EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListEnterpriseServiceAccountsResponse> {
            return localVarFp.enterpriseAPIListEnterpriseServiceAccounts(requestParameters.enterpriseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.organizationId, requestParameters.sortField, requestParameters.sortOrder, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * List all enterprise and child organizations groups
         * @summary List all enterprise and child organizations groups.
         * @param {EnterpriseAPIApiEnterpriseAPIListGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListGroups(requestParameters: EnterpriseAPIApiEnterpriseAPIListGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListGroupsResponse> {
            return localVarFp.enterpriseAPIListGroups(requestParameters.enterpriseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.organizationId, requestParameters.groupName, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all enterprise and child organizations users and invitations
         * @summary List all enterprise and child organizations users and invitations.
         * @param {EnterpriseAPIApiEnterpriseAPIListMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListMembers(requestParameters: EnterpriseAPIApiEnterpriseAPIListMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListMembersResponse> {
            return localVarFp.enterpriseAPIListMembers(requestParameters.enterpriseId, requestParameters.organizationId, requestParameters.roleId, requestParameters.groupId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.name, requestParameters.sortField, requestParameters.sortOrder, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * List all enterprise and child organizations role bindings
         * @summary List all enterprise and child organizations role bindings.
         * @param {EnterpriseAPIApiEnterpriseAPIListRoleBindingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIListRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIListRoleBindingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRoleBindingsResponse> {
            return localVarFp.enterpriseAPIListRoleBindings(requestParameters.enterpriseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.organizationId, requestParameters.roleId, requestParameters.subjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Override users role bindings for enterprise and child organizations
         * @summary Override user role bindings for enterprise and child organizations
         * @param {EnterpriseAPIApiEnterpriseAPIOverrideUserRoleBindingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseAPIOverrideUserRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIOverrideUserRoleBindingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.enterpriseAPIOverrideUserRoleBindings(requestParameters.enterpriseId, requestParameters.overrideUserRoleBindingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for enterpriseAPIAddUserToChildOrganization operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIAddUserToChildOrganizationRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIAddUserToChildOrganizationRequest {
    /**
     * Enterprise organization id which user is being managed.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIAddUserToChildOrganization
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {AddUserToChildOrganizationRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIAddUserToChildOrganization
     */
    readonly addUserToChildOrganizationRequest: AddUserToChildOrganizationRequest
}

/**
 * Request parameters for enterpriseAPIBatchCreateEnterpriseGroups operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseGroupsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseGroupsRequest {
    /**
     * Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseGroups
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {BatchCreateEnterpriseGroupsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseGroups
     */
    readonly batchCreateEnterpriseGroupsRequest: BatchCreateEnterpriseGroupsRequest
}

/**
 * Request parameters for enterpriseAPIBatchCreateEnterpriseRoleBindings operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseRoleBindingsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseRoleBindingsRequest {
    /**
     * Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseRoleBindings
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {BatchCreateEnterpriseRoleBindingsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseRoleBindings
     */
    readonly batchCreateEnterpriseRoleBindingsRequest: BatchCreateEnterpriseRoleBindingsRequest
}

/**
 * Request parameters for enterpriseAPIBatchCreateEnterpriseServiceAccounts operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseServiceAccountsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseServiceAccountsRequest {
    /**
     * ID of the enterprise organization.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseServiceAccounts
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {BatchCreateEnterpriseServiceAccountsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseServiceAccounts
     */
    readonly batchCreateEnterpriseServiceAccountsRequest: BatchCreateEnterpriseServiceAccountsRequest
}

/**
 * Request parameters for enterpriseAPIBatchDeleteEnterpriseGroups operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseGroupsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseGroupsRequest {
    /**
     * Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseGroups
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {BatchDeleteEnterpriseGroupsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseGroups
     */
    readonly batchDeleteEnterpriseGroupsRequest: BatchDeleteEnterpriseGroupsRequest
}

/**
 * Request parameters for enterpriseAPIBatchDeleteEnterpriseRoleBindings operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseRoleBindingsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseRoleBindingsRequest {
    /**
     * Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseRoleBindings
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {BatchDeleteEnterpriseRoleBindingsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseRoleBindings
     */
    readonly batchDeleteEnterpriseRoleBindingsRequest: BatchDeleteEnterpriseRoleBindingsRequest
}

/**
 * Request parameters for enterpriseAPIBatchDeleteEnterpriseServiceAccounts operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseServiceAccountsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseServiceAccountsRequest {
    /**
     * ID of the enterprise organization.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseServiceAccounts
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {BatchDeleteEnterpriseServiceAccountsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseServiceAccounts
     */
    readonly batchDeleteEnterpriseServiceAccountsRequest: BatchDeleteEnterpriseServiceAccountsRequest
}

/**
 * Request parameters for enterpriseAPIBatchUpdateEnterpriseGroups operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseGroupsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseGroupsRequest {
    /**
     * Required field that identifies the enterprise.  If this is set, the organization_id field in the UpdateGroupRequest messages  must either be empty or match organizations within this enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseGroups
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {BatchUpdateEnterpriseGroupsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseGroups
     */
    readonly batchUpdateEnterpriseGroupsRequest: BatchUpdateEnterpriseGroupsRequest
}

/**
 * Request parameters for enterpriseAPIBatchUpdateEnterpriseRoleBindings operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseRoleBindingsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseRoleBindingsRequest {
    /**
     * The ID of the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseRoleBindings
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {BatchUpdateEnterpriseRoleBindingsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseRoleBindings
     */
    readonly batchUpdateEnterpriseRoleBindingsRequest: BatchUpdateEnterpriseRoleBindingsRequest
}

/**
 * Request parameters for enterpriseAPIBatchUpdateEnterpriseServiceAccounts operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseServiceAccountsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseServiceAccountsRequest {
    /**
     * ID of the enterprise organization.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseServiceAccounts
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {BatchUpdateEnterpriseServiceAccountsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseServiceAccounts
     */
    readonly batchUpdateEnterpriseServiceAccountsRequest: BatchUpdateEnterpriseServiceAccountsRequest
}

/**
 * Request parameters for enterpriseAPICreateChildOrganization operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPICreateChildOrganizationRequest
 */
export interface EnterpriseAPIApiEnterpriseAPICreateChildOrganizationRequest {
    /**
     * Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPICreateChildOrganization
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {CreateChildOrganizationRequestChildOrganization}
     * @memberof EnterpriseAPIApiEnterpriseAPICreateChildOrganization
     */
    readonly createChildOrganizationRequestChildOrganization: CreateChildOrganizationRequestChildOrganization
}

/**
 * Request parameters for enterpriseAPIDeleteChildOrganization operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIDeleteChildOrganizationRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIDeleteChildOrganizationRequest {
    /**
     * Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIDeleteChildOrganization
     */
    readonly enterpriseId: string

    /**
     * Required field that identifies the child organization.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIDeleteChildOrganization
     */
    readonly id: string
}

/**
 * Request parameters for enterpriseAPIGetEnterpriseGroup operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIGetEnterpriseGroupRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIGetEnterpriseGroupRequest {
    /**
     * ID of the enterprise organization to which the group belongs.  Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIGetEnterpriseGroup
     */
    readonly enterpriseId: string

    /**
     * ID of the group to retrieve. Allows cross-organization lookup under the  enterprise - the group may belong to the parent enterprise or any of its  child organizations.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIGetEnterpriseGroup
     */
    readonly id: string
}

/**
 * Request parameters for enterpriseAPIGetEnterpriseMember operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIGetEnterpriseMemberRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIGetEnterpriseMemberRequest {
    /**
     * ID of the enterprise organization that owns the member.  Required field that identifies the enterprise (or one of its child organizations).
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIGetEnterpriseMember
     */
    readonly enterpriseId: string

    /**
     * ID of the member (user or invitation) to fetch.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIGetEnterpriseMember
     */
    readonly id: string

    /**
     * Kind of member to fetch. Required; must be either USER or INVITATION.
     * @type {'GET_ENTERPRISE_MEMBER_TYPE_UNSPECIFIED' | 'GET_ENTERPRISE_MEMBER_TYPE_USER' | 'GET_ENTERPRISE_MEMBER_TYPE_INVITATION'}
     * @memberof EnterpriseAPIApiEnterpriseAPIGetEnterpriseMember
     */
    readonly type?: EnterpriseAPIGetEnterpriseMemberTypeEnum
}

/**
 * Request parameters for enterpriseAPIInviteUsers operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIInviteUsersRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIInviteUsersRequest {
    /**
     * ID of the enterprise organization to invite users to.  Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIInviteUsers
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {InviteUsersRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIInviteUsers
     */
    readonly inviteUsersRequest: InviteUsersRequest
}

/**
 * Request parameters for enterpriseAPIListChildrenOrganizations operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIListChildrenOrganizationsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIListChildrenOrganizationsRequest {
    /**
     * Get organization children by organization id.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListChildrenOrganizations
     */
    readonly enterpriseId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListChildrenOrganizations
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListChildrenOrganizations
     */
    readonly pageCursor?: string

    /**
     * Filter by organization name
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListChildrenOrganizations
     */
    readonly organizationName?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListChildrenOrganizations
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof EnterpriseAPIApiEnterpriseAPIListChildrenOrganizations
     */
    readonly sortOrder?: EnterpriseAPIListChildrenOrganizationsSortOrderEnum
}

/**
 * Request parameters for enterpriseAPIListEnterpriseServiceAccounts operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccountsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccountsRequest {
    /**
     * ID of the enterprise organization to list service accounts from.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccounts
     */
    readonly enterpriseId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccounts
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccounts
     */
    readonly pageCursor?: string

    /**
     * Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y).
     * @type {Array<string>}
     * @memberof EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccounts
     */
    readonly organizationId?: Array<string>

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccounts
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccounts
     */
    readonly sortOrder?: EnterpriseAPIListEnterpriseServiceAccountsSortOrderEnum

    /**
     * Filter by name. Performs case-insensitive partial matching.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccounts
     */
    readonly name?: string
}

/**
 * Request parameters for enterpriseAPIListGroups operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIListGroupsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIListGroupsRequest {
    /**
     * ID of the enterprise organization to list groups from.  Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListGroups
     */
    readonly enterpriseId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListGroups
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListGroups
     */
    readonly pageCursor?: string

    /**
     * Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y)
     * @type {Array<string>}
     * @memberof EnterpriseAPIApiEnterpriseAPIListGroups
     */
    readonly organizationId?: Array<string>

    /**
     * Filter by group name
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListGroups
     */
    readonly groupName?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListGroups
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof EnterpriseAPIApiEnterpriseAPIListGroups
     */
    readonly sortOrder?: EnterpriseAPIListGroupsSortOrderEnum
}

/**
 * Request parameters for enterpriseAPIListMembers operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIListMembersRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIListMembersRequest {
    /**
     * ID of the enterprise organization to list users from  Required field that identifies the enterprise
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly enterpriseId: string

    /**
     * Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y)
     * @type {Array<string>}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly organizationId?: Array<string>

    /**
     * Filter by role ID. Multiple values can be passed as query parameters (e.g.,  &amp;role_id&#x3D;x&amp;role_id&#x3D;y)
     * @type {Array<string>}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly roleId?: Array<string>

    /**
     * Filter by group ID. Multiple values can be passed as query parameters  (e.g., &amp;group_id&#x3D;x&amp;group_id&#x3D;y)
     * @type {Array<string>}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly groupId?: Array<string>

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly pageCursor?: string

    /**
     * Filter by name.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly name?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly sortOrder?: EnterpriseAPIListMembersSortOrderEnum

    /**
     * Filter by status. Default is ALL.
     * @type {'MEMBER_STATUS_UNSPECIFIED' | 'MEMBER_STATUS_ALL' | 'MEMBER_STATUS_INVITE_PENDING' | 'MEMBER_STATUS_ACTIVE'}
     * @memberof EnterpriseAPIApiEnterpriseAPIListMembers
     */
    readonly status?: EnterpriseAPIListMembersStatusEnum
}

/**
 * Request parameters for enterpriseAPIListRoleBindings operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIListRoleBindingsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIListRoleBindingsRequest {
    /**
     * ID of the enterprise organization to list role bindings from.  Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListRoleBindings
     */
    readonly enterpriseId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListRoleBindings
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIListRoleBindings
     */
    readonly pageCursor?: string

    /**
     * Filter by organization ID. Multiple values can be passed as query  parameters (e.g., &amp;organization_id&#x3D;x&amp;organization_id&#x3D;y)
     * @type {Array<string>}
     * @memberof EnterpriseAPIApiEnterpriseAPIListRoleBindings
     */
    readonly organizationId?: Array<string>

    /**
     * Filter by role ID. Multiple values can be passed as query parameters (e.g.,  &amp;role_id&#x3D;x&amp;role_id&#x3D;y)
     * @type {Array<string>}
     * @memberof EnterpriseAPIApiEnterpriseAPIListRoleBindings
     */
    readonly roleId?: Array<string>

    /**
     * Filter by subject ID. Multiple values can be passed as query parameters (e.g.,  &amp;subject_id&#x3D;x&amp;subject_id&#x3D;y)
     * @type {Array<string>}
     * @memberof EnterpriseAPIApiEnterpriseAPIListRoleBindings
     */
    readonly subjectId?: Array<string>
}

/**
 * Request parameters for enterpriseAPIOverrideUserRoleBindings operation in EnterpriseAPIApi.
 * @export
 * @interface EnterpriseAPIApiEnterpriseAPIOverrideUserRoleBindingsRequest
 */
export interface EnterpriseAPIApiEnterpriseAPIOverrideUserRoleBindingsRequest {
    /**
     * Required field that identifies the enterprise.
     * @type {string}
     * @memberof EnterpriseAPIApiEnterpriseAPIOverrideUserRoleBindings
     */
    readonly enterpriseId: string

    /**
     * 
     * @type {OverrideUserRoleBindingsRequest}
     * @memberof EnterpriseAPIApiEnterpriseAPIOverrideUserRoleBindings
     */
    readonly overrideUserRoleBindingsRequest: OverrideUserRoleBindingsRequest
}

/**
 * EnterpriseAPIApi - object-oriented interface
 * @export
 * @class EnterpriseAPIApi
 * @extends {BaseAPI}
 */
export class EnterpriseAPIApi extends BaseAPI {
    /**
     * Add users to child organization
     * @param {EnterpriseAPIApiEnterpriseAPIAddUserToChildOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIAddUserToChildOrganization(requestParameters: EnterpriseAPIApiEnterpriseAPIAddUserToChildOrganizationRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIAddUserToChildOrganization(requestParameters.enterpriseId, requestParameters.addUserToChildOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch creates groups in an enterprise or child organizations
     * @summary Batch creates groups in an enterprise or child organizations.
     * @param {EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIBatchCreateEnterpriseGroups(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseGroupsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIBatchCreateEnterpriseGroups(requestParameters.enterpriseId, requestParameters.batchCreateEnterpriseGroupsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch creates role bindings in an enterprise or child organizations
     * @summary Batch creates role bindings in an enterprise or child organizations.
     * @param {EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseRoleBindingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIBatchCreateEnterpriseRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseRoleBindingsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIBatchCreateEnterpriseRoleBindings(requestParameters.enterpriseId, requestParameters.batchCreateEnterpriseRoleBindingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch creates service accounts in an enterprise or child organizations.
     * @summary Batch creates service accounts in an enterprise or child organizations.
     * @param {EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseServiceAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIBatchCreateEnterpriseServiceAccounts(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchCreateEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIBatchCreateEnterpriseServiceAccounts(requestParameters.enterpriseId, requestParameters.batchCreateEnterpriseServiceAccountsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch delete enterprise groups
     * @summary Batch delete enterprise groups.
     * @param {EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIBatchDeleteEnterpriseGroups(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseGroupsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIBatchDeleteEnterpriseGroups(requestParameters.enterpriseId, requestParameters.batchDeleteEnterpriseGroupsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch delete enterprise role bindings
     * @summary Batch delete enterprise role bindings.
     * @param {EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseRoleBindingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIBatchDeleteEnterpriseRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseRoleBindingsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIBatchDeleteEnterpriseRoleBindings(requestParameters.enterpriseId, requestParameters.batchDeleteEnterpriseRoleBindingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch delete enterprise service accounts
     * @summary Batch delete enterprise service accounts.
     * @param {EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseServiceAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIBatchDeleteEnterpriseServiceAccounts(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchDeleteEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIBatchDeleteEnterpriseServiceAccounts(requestParameters.enterpriseId, requestParameters.batchDeleteEnterpriseServiceAccountsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch updates groups in an enterprise or child organizations
     * @summary Batch updates groups in an enterprise or child organizations.
     * @param {EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIBatchUpdateEnterpriseGroups(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseGroupsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIBatchUpdateEnterpriseGroups(requestParameters.enterpriseId, requestParameters.batchUpdateEnterpriseGroupsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a batch of enterprise role bindings.
     * @summary Batch update enterprise role bindings
     * @param {EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseRoleBindingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIBatchUpdateEnterpriseRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseRoleBindingsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIBatchUpdateEnterpriseRoleBindings(requestParameters.enterpriseId, requestParameters.batchUpdateEnterpriseRoleBindingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch updates service accounts in an enterprise or child organizations.
     * @summary Batch updates service accounts in an enterprise or child organizations.
     * @param {EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseServiceAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIBatchUpdateEnterpriseServiceAccounts(requestParameters: EnterpriseAPIApiEnterpriseAPIBatchUpdateEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIBatchUpdateEnterpriseServiceAccounts(requestParameters.enterpriseId, requestParameters.batchUpdateEnterpriseServiceAccountsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates child organization for an enterprise
     * @summary Create child organization for an enterprise organization
     * @param {EnterpriseAPIApiEnterpriseAPICreateChildOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPICreateChildOrganization(requestParameters: EnterpriseAPIApiEnterpriseAPICreateChildOrganizationRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPICreateChildOrganization(requestParameters.enterpriseId, requestParameters.createChildOrganizationRequestChildOrganization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes child organization for an enterprise
     * @summary Delete child organization for an enterprise organization
     * @param {EnterpriseAPIApiEnterpriseAPIDeleteChildOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIDeleteChildOrganization(requestParameters: EnterpriseAPIApiEnterpriseAPIDeleteChildOrganizationRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIDeleteChildOrganization(requestParameters.enterpriseId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetEnterpriseGroup returns the group of an enterprise organization
     * @summary Get enterprise group.
     * @param {EnterpriseAPIApiEnterpriseAPIGetEnterpriseGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIGetEnterpriseGroup(requestParameters: EnterpriseAPIApiEnterpriseAPIGetEnterpriseGroupRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIGetEnterpriseGroup(requestParameters.enterpriseId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a single enterprise member (user or invitation) by id from the enterprise or its child organizations.
     * @summary Get a single enterprise member (user or invitation) by id.
     * @param {EnterpriseAPIApiEnterpriseAPIGetEnterpriseMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIGetEnterpriseMember(requestParameters: EnterpriseAPIApiEnterpriseAPIGetEnterpriseMemberRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIGetEnterpriseMember(requestParameters.enterpriseId, requestParameters.id, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create invitations for multiple users to join child organizations by email
     * @summary Invite users to child organizations.
     * @param {EnterpriseAPIApiEnterpriseAPIInviteUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIInviteUsers(requestParameters: EnterpriseAPIApiEnterpriseAPIInviteUsersRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIInviteUsers(requestParameters.enterpriseId, requestParameters.inviteUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all children organizations of the enterprise from the token.
     * @summary List all children organizations of the enterprise from the token.
     * @param {EnterpriseAPIApiEnterpriseAPIListChildrenOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIListChildrenOrganizations(requestParameters: EnterpriseAPIApiEnterpriseAPIListChildrenOrganizationsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIListChildrenOrganizations(requestParameters.enterpriseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.organizationName, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all enterprise and child organizations service accounts
     * @summary List all enterprise and child organizations service accounts.
     * @param {EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIListEnterpriseServiceAccounts(requestParameters: EnterpriseAPIApiEnterpriseAPIListEnterpriseServiceAccountsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIListEnterpriseServiceAccounts(requestParameters.enterpriseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.organizationId, requestParameters.sortField, requestParameters.sortOrder, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all enterprise and child organizations groups
     * @summary List all enterprise and child organizations groups.
     * @param {EnterpriseAPIApiEnterpriseAPIListGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIListGroups(requestParameters: EnterpriseAPIApiEnterpriseAPIListGroupsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIListGroups(requestParameters.enterpriseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.organizationId, requestParameters.groupName, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all enterprise and child organizations users and invitations
     * @summary List all enterprise and child organizations users and invitations.
     * @param {EnterpriseAPIApiEnterpriseAPIListMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIListMembers(requestParameters: EnterpriseAPIApiEnterpriseAPIListMembersRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIListMembers(requestParameters.enterpriseId, requestParameters.organizationId, requestParameters.roleId, requestParameters.groupId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.name, requestParameters.sortField, requestParameters.sortOrder, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all enterprise and child organizations role bindings
     * @summary List all enterprise and child organizations role bindings.
     * @param {EnterpriseAPIApiEnterpriseAPIListRoleBindingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIListRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIListRoleBindingsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIListRoleBindings(requestParameters.enterpriseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.organizationId, requestParameters.roleId, requestParameters.subjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override users role bindings for enterprise and child organizations
     * @summary Override user role bindings for enterprise and child organizations
     * @param {EnterpriseAPIApiEnterpriseAPIOverrideUserRoleBindingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseAPIApi
     */
    public enterpriseAPIOverrideUserRoleBindings(requestParameters: EnterpriseAPIApiEnterpriseAPIOverrideUserRoleBindingsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseAPIApiFp(this.configuration).enterpriseAPIOverrideUserRoleBindings(requestParameters.enterpriseId, requestParameters.overrideUserRoleBindingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const EnterpriseAPIGetEnterpriseMemberTypeEnum = {
    UNSPECIFIED: 'GET_ENTERPRISE_MEMBER_TYPE_UNSPECIFIED',
    USER: 'GET_ENTERPRISE_MEMBER_TYPE_USER',
    INVITATION: 'GET_ENTERPRISE_MEMBER_TYPE_INVITATION'
} as const;
export type EnterpriseAPIGetEnterpriseMemberTypeEnum = typeof EnterpriseAPIGetEnterpriseMemberTypeEnum[keyof typeof EnterpriseAPIGetEnterpriseMemberTypeEnum];
/**
 * @export
 */
export const EnterpriseAPIListChildrenOrganizationsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type EnterpriseAPIListChildrenOrganizationsSortOrderEnum = typeof EnterpriseAPIListChildrenOrganizationsSortOrderEnum[keyof typeof EnterpriseAPIListChildrenOrganizationsSortOrderEnum];
/**
 * @export
 */
export const EnterpriseAPIListEnterpriseServiceAccountsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type EnterpriseAPIListEnterpriseServiceAccountsSortOrderEnum = typeof EnterpriseAPIListEnterpriseServiceAccountsSortOrderEnum[keyof typeof EnterpriseAPIListEnterpriseServiceAccountsSortOrderEnum];
/**
 * @export
 */
export const EnterpriseAPIListGroupsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type EnterpriseAPIListGroupsSortOrderEnum = typeof EnterpriseAPIListGroupsSortOrderEnum[keyof typeof EnterpriseAPIListGroupsSortOrderEnum];
/**
 * @export
 */
export const EnterpriseAPIListMembersSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type EnterpriseAPIListMembersSortOrderEnum = typeof EnterpriseAPIListMembersSortOrderEnum[keyof typeof EnterpriseAPIListMembersSortOrderEnum];
/**
 * @export
 */
export const EnterpriseAPIListMembersStatusEnum = {
    UNSPECIFIED: 'MEMBER_STATUS_UNSPECIFIED',
    ALL: 'MEMBER_STATUS_ALL',
    INVITE_PENDING: 'MEMBER_STATUS_INVITE_PENDING',
    ACTIVE: 'MEMBER_STATUS_ACTIVE'
} as const;
export type EnterpriseAPIListMembersStatusEnum = typeof EnterpriseAPIListMembersStatusEnum[keyof typeof EnterpriseAPIListMembersStatusEnum];
